// extracted by mini-css-extract-plugin
export default {"products":"Wv-z","card":"Xv-z","oosMessaging":"Yv-z"};